import { AnimatePresence, motion } from "framer-motion";
import Image from "@/components/ui/Image";

export const PageTransitionLoader = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
        >
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: [0, 1, 1, 0], opacity: [0, 1, 1, 0] }}
            transition={{
              duration: 1,
              ease: "easeInOut",
              times: [0, 0.4, 0.6, 1],
            }}
          >
            <Image
              src="/images/estrellajartinet.svg"
              alt="Jartiland"
              className="w-24 h-24 text-primary"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
